const isPhotoColorizer = location.pathname.includes('photo-colorizer');
import { LOCAL } from '../../constants/FJEvnConstant';
import FJVersionConfig from '../FJVersionConfig';

const environment = import.meta.env.MODE;

export default {
    originalImageKey: 'ai/input/image-group/',
    resultImageKey: 'ai/export/image-group/',
    historyListType: 4,
    freeLimitType: 'image-manipulation',
    currentMenuName: !isPhotoColorizer ? 'ai-old-photo-restoration' : 'ai-photo-colorizer',
    notImageBoxBgUrl:
        environment === LOCAL
            ? `/public/img/imageManipulation/bg.png?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/imageManipulation/bg.png?v=${FJVersionConfig.staticPathVersion}`,
    notImageBoxVideoUrl:
        environment === LOCAL
            ? `/public/img/imageManipulation/video.mp4?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/imageManipulation/video.mp4?v=${FJVersionConfig.staticPathVersion}`,
    eraseTipsVideoUrl:
        environment === LOCAL
            ? `/public/img/oldPhotoRestoration/erase-tips.mp4?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/oldPhotoRestoration/erase-tips.mp4?v=${FJVersionConfig.staticPathVersion}`,
};
